import { combineReducers } from '@reduxjs/toolkit';
import notificationsReducer from '../notifications/reducer';
import multiUserReducer from './multiuser/reducer';
import previewReducer from './preview/reducer';
import appProjectEditorReducer from './projects/reducer';
import manipulationReducer from './manipulation/reducer';
import themingReducer from '../theming/reducer';
import dialogsReducer from '../dialogs/reducer';

const reducer = combineReducers({
  notifications: notificationsReducer,
  dialogs: dialogsReducer,
  multiuser: multiUserReducer,
  preview: previewReducer,
  editor: appProjectEditorReducer,
  manipulation: manipulationReducer,
  theming: themingReducer,
});

export type AppProjectEditorRootState = ReturnType<typeof reducer>;

export default reducer;
